
    <app-kontable
      id="dt_brand"
      title="{{ 'promotion.campaignTypesSectionTitle' | translate }}"
      [columns]="['id', 'code', 'description', 'check_impl_class']"
      [titles]="['#', 'promotion.code', 'promotion.description', 'promotion.checkImplClass']"
      [source]="campaignTypes"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-campaign-type-detail
        *ngIf="show"
        (back)="toggleShow()"
        [titlePage]="titlePage"
        [campaignType]="addEditCampaignType"
        (saveCampaignType)="save($event)">
    </kv-promo-campaign-type-detail>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign-type/campaign-type.component.ts.CampaignTypeComponent.html